module.exports = function(h, row) {
    let length = row.tags.length;

    if (length < 1) {
        return <i>No tags assigned</i>;
    }

    if (length == 1) {
        return row.tags[0].name;
    }

    if (length == 2) {
        return row.tags[0].name + ' and ' + row.tags[1].name;
    }

    if (length > 2) {
        return (
            row.tags[0].name +
            ', ' +
            row.tags[1].name +
            ', ' +
            '+' +
            (length - 2) +
            ' tags'
        );
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/discount/colums/tags.jsx